'use strict';

const $buttonGroup = $('.pdf-switcher-container .button-group');
const $dfBook = $('._df_book');
const $sidebarItems = $('.sidebar-items .sidebar-item');


/**
 * Creates PDF switcher buttons based on sidebar items
 */
function createPdfButtons() {
    $buttonGroup.empty();
    
    // Create a button for each sidebar item
    $sidebarItems.each(function(index) {
        const $sidebarItem = $(this);
        const pdfUrl = $sidebarItem.data('file');
        const contentId = $sidebarItem.data('content-id');
        const title = $sidebarItem.find('.sidebar-item-title').text().trim();
        const href = $sidebarItem.data('href');
        
        const $button = $('<button>')
            .addClass('switch-button')
            .attr('data-pdf-url', pdfUrl)
            .attr('data-content-id', contentId)
            .attr('data-href', href);
            
        // Make first button active by default
        if (index === 0) {
            $button.addClass('active');
            // Set initial PDF source if not already set
            if (!$dfBook.attr('source')) {
                $dfBook.attr('source', pdfUrl);
            }
        }
        
        // Create button content
        const $buttonContent = $('<div>').addClass('button-content');
        const $buttonText = $('<span>').addClass('button-text').text(title);
   
        $buttonContent.append($buttonText);
        $button.append($buttonContent);
        $buttonGroup.append($button);
    });
}

/**
 * Sets the initial active button based on URL parameter
 */
function setInitialActiveButton() {
    const urlParams = new URLSearchParams(window.location.search);
    const contentParam = urlParams.get('content');
    
    if (contentParam) {
        const $matchingButton = $(`.switch-button[data-content-id="${contentParam}"]`);
        if ($matchingButton.length) {
            $('.switch-button').removeClass('active');
            $matchingButton.addClass('active');
            
            $(`.pdf-switcher-container ._df_book[data-content-id="${contentParam}"]`).show();
        }
    }
}

/**
 * Initializes go to top button functionality
 */
function initGoToTop() {
    var $goToTopBtn = $('.go-to-top-btn');
    
    if ($goToTopBtn.length) {
        $goToTopBtn.on('click', function(e) {
            e.preventDefault();
            $('html').animate({ scrollTop: 0 }, 'smooth');
        });
    }
}

/**
 * Initializes the bulletin feature
 */
const initBulletin = function() {
    createPdfButtons();
    
    setInitialActiveButton();

    $buttonGroup.on('click', '.switch-button', function(event) {
        window.location.href = $(event.currentTarget).attr('data-href');
    });
    initGoToTop();
};

module.exports = {
    initBulletin: initBulletin
};